module.exports = __webpack_public_path__ + "static/media/map_continue.be420b68.mp4";